<template>
  <v-edit-dialog
    :return-value.sync="produto.preco_custo"
    @save="atualizarProdutoNoPedidoDeCompra()"
    @open="buscarProdutoNoPedidoDeCompra()"
    large
    cancel-text="cancelar"
    save-text="salvar"
    transition="fab-transition"
  >
    <v-tooltip top open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <span>Editar Produto no pedido de compra.</span>
    </v-tooltip>

    <template v-slot:input>
      <v-card width="300px" height="270" elevation="0">
        <v-card-title class="px-0">
          Edição do Produto
        </v-card-title>

        <p class="caption">
          <v-icon small>mdi-cart</v-icon>
          Carrinho de Compra N° {{ editedItem.idpedido }}
        </p>

        <v-card-text class="pa-0">
          <template v-if="!loading && editedItem">
            <text-field-formatador
              v-model="editedItem.preco_custo"
              label="Preço"
              dense
              outlined
              :disabled="loading"
              class="mt-3"
              :max-digitos="configuracoes.CASAS_DECIMAIS_CARRINHO"
            ></text-field-formatador>

            <text-field-formatador
              v-model="editedItem.qtde_pedido"
              label="Quantidade do Pedido"
              dense
              outlined
              :disabled="loading"
              :max-digitos="configuracoes.CASAS_DECIMAIS_CARRINHO"
            ></text-field-formatador>

            <v-btn small color="error" @click="dialogConfirmacao = true">
              <v-icon left>mdi-delete</v-icon>
              remover do carrinho
            </v-btn>
          </template>
          <template v-else>
            <div class="d-flex justify-center my-4">
              <v-progress-circular
                indeterminate
                color="red"
                class="mt-14"
              ></v-progress-circular>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </template>

    <dialog-confimacao
      v-model="dialogConfirmacao"
      :messages="['Deseja realmente remover este item do carrinho de Compra?']"
      icon="mdi-delete"
      color="error"
      @confirmado="excluirProdutoDoPedidoDeCompra()"
    />
  </v-edit-dialog>
</template>

<script>
import TextFieldFormatador from '../../utils/TextFieldFormatadorDeValor'
import CarrinhoAPI from '../../../api/carrinho'
import DialogConfimacao from '../../utils/DialogConfirmacao'
import {mapGetters} from 'vuex'

export default {
  name: 'EdicaoCarrinhoDialog',
  components: {TextFieldFormatador, DialogConfimacao},
  props: {
    produto: {type: Object, required: true}
  },
  data: () => ({
    editedItem: {},
    loading: true,
    dialogConfirmacao: false
  }),
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster"
    }),
  },
  methods: {
    buscarProdutoNoPedidoDeCompra () {
      this.loading = true

      const headers = this.Helpers.iniciarRequisicao()
      const params = {
        filial_compra: this.produto.filial,
        idfornecedor: this.produto.idfornecedor,
        idproduto: this.produto.idproduto,
      }

      CarrinhoAPI.getProdutoDoPedido(headers, params)
        .then(response => {
          const {token, produto} = response.data
          localStorage.token = token
          this.editedItem = produto
          this.loading = false

          if (this.embalagemMasterAtivada) {
            this.converterEmbalagemParaMaster();
          }
        })
        .catch(() => this.Helpers.logout())
    },
    atualizarProdutoNoPedidoDeCompra () {
      this.loading = true

      if (this.embalagemMasterAtivada) {
        this.converterEmbalagemParaMinima();
      }

      const params = {
        fornecedor: this.produto.idfornecedor,
        produto: this.produto.idproduto,
        grupo: this.editedItem.grupo,
        filial: this.produto.filial,
        qtde: this.editedItem.qtde_pedido,
        preco_custo: this.editedItem.preco_custo
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        this.$store.dispatch("carrinho/Store", params)
          .then(() => {
            this.loading = false
          })
      );
    },
    excluirProdutoDoPedidoDeCompra () {
      this.loading = true

      const params = {
        fornecedor: this.produto.idfornecedor,
        grupo: this.editedItem.grupo,
        pedido: this.editedItem.idpedido,
        produto: this.editedItem.idproduto,
      }

      this.$store.dispatch("loading/addRequisicao",
        this.$store.dispatch("carrinho/Delete", params)
          .then(() => {
            this.loading = false
            this.$emit('produto-removido-do-carrinho', {})
          })
      );
    },
    converterEmbalagemParaMaster() {
      const {preco_custo, qtde_pedido} = this.editedItem;

      this.editedItem.preco_custo = preco_custo * this.produto.multiplo_compra;
      this.editedItem.qtde_pedido = qtde_pedido / this.produto.multiplo_compra;
    },
    converterEmbalagemParaMinima() {
      const {preco_custo, qtde_pedido} = this.editedItem;

      this.editedItem.preco_custo = preco_custo / this.produto.multiplo_compra;
      this.editedItem.qtde_pedido = qtde_pedido * this.produto.multiplo_compra;
    },
  }
}
</script>

<style scoped>

</style>
